/* eslint-disable camelcase */
export default class FeatureSetting {
  /**
   * Feature Setting entity
   * @param {string} feature_setting_name
   * @param {string} feature_setting_value
   */
  constructor ({ feature_setting_name, feature_setting_value }) {
    this.name = feature_setting_name
    this.value = feature_setting_value
  }
}
